import { tabsGuide } from '../../content/methodology';

interface Props {
  onTabSwitch: (tab: 'today' | 'tracked' | 'analyses' | 'methodology') => void;
}

export function TabsGuide({ onTabSwitch }: Props) {
  return (
    <section className="tabs-guide">
      <h3>Kde co najdete</h3>
      <div className="tabs-guide__grid">
        {tabsGuide.map((item) => (
          <button
            key={item.tab}
            className="tabs-guide__card"
            style={{ borderLeftColor: item.accentColor }}
            onClick={() => onTabSwitch(item.tab)}
          >
            <div className="tabs-guide__card-eyebrow" style={{ color: item.accentColor }}>{item.label}</div>
            <div className="tabs-guide__card-question">{item.question}</div>
            <p className="tabs-guide__card-desc">{item.description}</p>
          </button>
        ))}
      </div>
    </section>
  );
}
